<template>
  <div class="mega-menu__topics-wrapper">
    <div
      class="mega-menu__topics"
      v-if="getCategoryDetails(category.name).topics.length"
    >
      <div class="mega-menu__topic-label">Topics</div>
      <div
        v-for="(topic, idx) in getCategoryDetails(category.name).topics"
        :key="`topic-${idx}`"
        class="mega-menu__topic"
        @click="openCategorySearch(topic)"
      >
        {{ topic.name }}
      </div>
    </div>
    <router-link
      class="mega-menu__view-all"
      @click.native="$emit('closeMegaMenu')"
      :to="{ name: 'learning-area', params: { id: category.id } }"
    >
      View All
      <span class="mega-menu__arrow material-icons">keyboard_arrow_right</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Topics',
  props: {
    category: {
      type: Object,
      required: true,
    },
    getCategoryDetails: {
      type: Function,
      required: true,
    },
    openCategorySearch: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.mega-menu {
  &__topics-wrapper {
    position: absolute;
    transform: translateY(100%);
    bottom: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    text-align: center;
    transition: all 0.2s ease-out;
  }
  &__topics {
    display: inline-block;
    text-align: left;
    margin: 0 0 60px 0;
  }
  &__topic-label {
    text-transform: uppercase;
    font-size: (14 / 16) * 1rem;
    color: var(--gray);
    margin: 0 0 20px 0;
    line-height: 1;
  }
  &__topic {
    color: var(--white);
    white-space: nowrap;
    line-height: 1;
    font-size: (18 / 16) * 1rem;
    margin: 0 0 20px 0;
    cursor: pointer;
    &:last-child {
      margin: 0;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  &__view-all {
    background: #222;
    text-transform: uppercase;
    color: var(--white);
    padding: 8px 15px;
    line-height: 1;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    font-size: (14 / 16) * 1rem;
    margin: 0 auto;
  }
  &__arrow {
    color: var(--orange);
    font-size: (18 / 16) * 1rem;
  }
}
</style>
